export const TABLE_REORDERING_TYPE = Symbol('reordering');
